// extracted by mini-css-extract-plugin
export default {"black":"#1c1b20","white":"#fff","mineShaft":"#313131","alabaster":"#f8f8f8","shark":"#1e1e1f","shark2":"#2b2b2c","shark3":"#202022","primaryText":"#313131"};